import React, { useEffect, useState } from "react";
import { MyModal } from "../../../../components/styled-components";

interface PdfRender {
  visible: boolean;
  onCancel: () => void;
  order_no: string;
  file_path: string;
}

const PreviewModal: React.FC<PdfRender> = ({ visible, onCancel, order_no, file_path }) => {
  const [filePath, setFilePath] = useState("");
  useEffect(() => {
    fetchFilePath();
  }, [visible, order_no, file_path]);

  const fetchFilePath = async () => {
    if (visible && order_no && file_path) {
      setFilePath(file_path);
    }
  };

  const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(filePath)}&embedded=true`;
  return (
    <MyModal title="PDF Viewer" open={visible} onOk={onCancel} onCancel={onCancel} footer={null}>
      {filePath ? (
        <iframe src={viewerUrl} width="100%" height="500px" title="PDF Preview"></iframe>
      ) : (
        <p>Loading PDF...</p> // Placeholder text or loading spinner
      )}
    </MyModal>
  );
};
export default PreviewModal;
